import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { finalize } from 'rxjs/operators';

import { HelpModalComponentState } from '../interfaces/help-modal-component-state.interface';
import { HelpModalInfo } from '../interfaces/help-modal-info.interface';

import { HelpModalService } from '../services/help-modal.service';
import { YChartsSentryUtils } from 'Angular/services/sentry/sentry-utils';

/**
 *
 * Help Modal Component
 *
 */

@Component({
    standalone: false,
    selector: 'ycn-help-modal',
    templateUrl: './help-modal.template.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpModalComponent {
    state: HelpModalComponentState;

    constructor(private changeDetector: ChangeDetectorRef, private helpModalService: HelpModalService) {
        this.state = {
            helpModalInfo: null,
            loading: true,
            modalOpen: false,
            error: false,
        };
    }

    public openModal(name: string): void {
        this.helpModalService
            .getHelpPopup(name)
            .pipe(
                finalize(() => {
                    this.state.loading = false;
                    this.state.modalOpen = true;
                    this.changeDetector.markForCheck();
                })
            )
            .subscribe({
                next: (data: HelpModalInfo) => {
                    this.state.helpModalInfo = data;
                    this.state.error = false;
                },
                error: (e) => {
                    this.state.helpModalInfo = null;
                    this.state.error = true;
                    YChartsSentryUtils.captureException(e);
                },
            });
    }

    public closeModal(): void {
        this.state.modalOpen = false;
        this.changeDetector.markForCheck();
    }
}
